export default function (width = 35, height = 35) {
  return `<svg width="${width}px" height="${height}px" viewBox="0 0 48 38" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect x="36.3127" width="12" height="36" rx="6" transform="rotate(20 36.3127 0)" fill="#6AD55E" fill-opacity="0.9"/>
  <rect x="16" y="4.10425" width="12" height="36" rx="6" transform="rotate(-20 16 4.10425)" fill="#FFD80B" fill-opacity="0.9"/>
  <rect x="20.3127" width="12" height="36" rx="6" transform="rotate(20 20.3127 0)" fill="#FF9227" fill-opacity="0.9"/>
  <rect y="4.10425" width="12" height="36" rx="6" transform="rotate(-20 0 4.10425)" fill="#406AFF" fill-opacity="0.9"/>
  </svg>`;
}
